(function () {
  let ESC_KEY = 27;

  var transitionEnd = (function () {
    var el = document.createElement("bootstrap");

    var transEndEventNames = {
      WebkitTransition: "webkitTransitionEnd",
      MozTransition: "transitionend",
      OTransition: "oTransitionEnd otransitionend",
      transition: "transitionend",
    };

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return transEndEventNames[name];
      }
    }

    return false; // explicit for ie8 (  ._.)
  })();

  // Main entry point for this js. Handle open and close action of drawer.

  $("[data-drawer-toggle]").attr({
    role: "button",
    "aria-expanded": "false",
  });

  $("[data-drawer-id]").attr({
    "aria-hidden": "true",
    "aria-expanded": "false",
  });

  // Listen to [drawer-toggle] element's action
  // Trigger 'toggle' function when element on click

  $("[data-drawer-toggle]").click(function () {
    toggleEl($(this));
  });

  // If toggle
  // Trigger 'toggle' if data-drawer-toggle has class active
  if ($(".active[data-drawer-toggle]")) {
    $(".active[data-drawer-toggle]").click();
  }

  // Listen to esc key to close the drawer
  $(document).on("keydown.toggle-drawer", function (e) {
    var key = e.keyCode || e.which;
    if (key == ESC_KEY) {
      toggleEl(e);
    }
  });
})();

function toggleEl(e) {
  var toggler = e;
  var container = $("[data-drawer-container]");
  if (!container.hasClass("drawer-open")) openDrawer(toggler, container);
  else closeDrawer(toggler, container);
}

export function openDrawer(toggler, container) {
  var drawer = getTogglerDrawerElement(toggler);

  setTimeout(function () {
    container.addClass("drawer-open");

    if (toggler.has("[data-drawer-toggle]")) {
      container.addClass("drawer-open--" + toggler.attr("data-drawer-toggle"));
      $(
        '[data-drawer-toggle="' + toggler.attr("data-drawer-toggle") + '"]'
      ).attr("aria-expanded", "true");
      drawer.attr({
        "aria-hidden": "false",
        "aria-expanded": "true",
      });
      let firstInput = drawer.find("input").get(0);
      if (firstInput) firstInput.focus();
    }
  }, 25);
}

export function closeDrawer(toggler, container) {
  var currentDrawer = getCurrentDrawer();
  var drawer = $('[data-drawer-id="' + currentDrawer + '"]');

  container.removeClass(getDrawerClass);

  $('[data-drawer-toggle="' + currentDrawer + '"]').attr(
    "aria-expanded",
    "false"
  );
  let firstInput = drawer.find("input").first();
  if (firstInput) firstInput.focusout();
  drawer.attr({
    "aria-hidden": "true",
    "aria-expanded": "false",
  });
}

function getDrawerClass(index, className) {
  var result = "";
  var array = className.split(" ");

  for (var i = 0; i < array.length; i++) {
    if (array[i].match("drawer-open")) result += array[i] + " ";
  }

  return result;
}

function getCurrentDrawer() {
  var container = $("[data-drawer-container]");
  var array = container.attr("class").split(" ");

  for (var i = 0; i < array.length; i++) {
    if (array[i].match("drawer-open--")) {
      return array[i].replace("drawer-open--", "");
    }
  }

  return null;
}

function getTogglerDrawerElement(toggler) {
  return $('[data-drawer-id="' + toggler.attr("data-drawer-toggle") + '"]');
}
